export function getTaavonBackendAddress(province) {
  switch (province) {
    case "hamedan":
      return "https://habackend.rasadyar.com/";
    case "markazi":
      return "https://mabackend.rasadyar.com/";
    default:
      return "https://testbackend.rasadyar.com/";
  }
}
